var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "client",
      attrs: { rules: _vm.rules, model: _vm.client, "label-width": "120px" }
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "Kundenklasse" } },
        [
          _c(
            "el-select",
            {
              attrs: { placeholder: "Anrede wählen" },
              model: {
                value: _vm.client.class_id,
                callback: function($$v) {
                  _vm.$set(_vm.client, "class_id", $$v)
                },
                expression: "client.class_id"
              }
            },
            [
              _c("el-option", { attrs: { label: "-", value: "0" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "A", value: "1" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "B", value: "2" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "C", value: "3" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "D", value: "4" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "E", value: "5" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "F", value: "6" } })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Firma" } },
        [
          _c("el-input", {
            model: {
              value: _vm.client.company,
              callback: function($$v) {
                _vm.$set(_vm.client, "company", $$v)
              },
              expression: "client.company"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Anrede" } },
        [
          _c(
            "el-select",
            {
              model: {
                value: _vm.client.sex_id,
                callback: function($$v) {
                  _vm.$set(_vm.client, "sex_id", $$v)
                },
                expression: "client.sex_id"
              }
            },
            [
              _c("el-option", { attrs: { label: "Herr", value: "1" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "Frau", value: "2" } })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Vorname" } },
        [
          _c("el-input", {
            model: {
              value: _vm.client.prename,
              callback: function($$v) {
                _vm.$set(_vm.client, "prename", $$v)
              },
              expression: "client.prename"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Name", prop: "name" } },
        [
          _c("el-input", {
            model: {
              value: _vm.client.name,
              callback: function($$v) {
                _vm.$set(_vm.client, "name", $$v)
              },
              expression: "client.name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Straße und Nr." } },
        [
          _c("el-input", {
            model: {
              value: _vm.client.street,
              callback: function($$v) {
                _vm.$set(_vm.client, "street", $$v)
              },
              expression: "client.street"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Zusatz" } },
        [
          _c("el-input", {
            model: {
              value: _vm.client.additional_1,
              callback: function($$v) {
                _vm.$set(_vm.client, "additional_1", $$v)
              },
              expression: "client.additional_1"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "PLZ" } },
        [
          _c("el-input", {
            model: {
              value: _vm.client.zip,
              callback: function($$v) {
                _vm.$set(_vm.client, "zip", $$v)
              },
              expression: "client.zip"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Ort" } },
        [
          _c("el-input", {
            model: {
              value: _vm.client.city,
              callback: function($$v) {
                _vm.$set(_vm.client, "city", $$v)
              },
              expression: "client.city"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Land" } },
        [
          _c(
            "el-select",
            {
              attrs: { placeholder: "Anrede wählen" },
              model: {
                value: _vm.client.country_id,
                callback: function($$v) {
                  _vm.$set(_vm.client, "country_id", $$v)
                },
                expression: "client.country_id"
              }
            },
            [
              _c("el-option", { attrs: { value: "1", label: "Deutschland" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "2", label: "Österreich" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "3", label: "Schweiz" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "4", label: "Liechtenstein" } })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "E-Mail", prop: "main_mail" } },
        [
          _c("el-input", {
            model: {
              value: _vm.client.main_mail,
              callback: function($$v) {
                _vm.$set(_vm.client, "main_mail", $$v)
              },
              expression: "client.main_mail"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Telefonnummer" } },
        [
          _c("el-input", {
            model: {
              value: _vm.client.phone,
              callback: function($$v) {
                _vm.$set(_vm.client, "phone", $$v)
              },
              expression: "client.phone"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Mobil" } },
        [
          _c("el-input", {
            model: {
              value: _vm.client.mobile,
              callback: function($$v) {
                _vm.$set(_vm.client, "mobile", $$v)
              },
              expression: "client.mobile"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Umsatzsteuer ID" } },
        [
          _c("el-input", {
            model: {
              value: _vm.client.ust_id,
              callback: function($$v) {
                _vm.$set(_vm.client, "ust_id", $$v)
              },
              expression: "client.ust_id"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "success" },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [_vm._v("Kunde anlegen")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }